import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0b5141e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "preview-item"
};
const _hoisted_2 = {
  class: "preview-item-image"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "preview-item-info"
};
const _hoisted_5 = {
  class: "preview-item-title"
};
const _hoisted_6 = {
  class: "preview-item-rating"
};
const _hoisted_7 = {
  class: "preview-item-score"
};
const _hoisted_8 = {
  class: "preview-item-count"
};
const _hoisted_9 = {
  class: "preview-item-price"
};
const _hoisted_10 = {
  class: "preview-item-price-main"
};
const _hoisted_11 = {
  class: "preview-item-price-secondary"
};
const _hoisted_12 = {
  class: "preview-item-delivery"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_rating = _resolveComponent("app-rating");
  const _component_app_icon = _resolveComponent("app-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: $props.product.image,
    alt: ""
  }, null, 8, _hoisted_3)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($props.product.product_name), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString($props.product.rating), 1), _createVNode(_component_app_rating, {
    rating: $props.product.rating,
    size: 16
  }, null, 8, ["rating"]), _createVNode(_component_app_icon, {
    icon: "chevron-down2",
    size: 14
  }), _createElementVNode("div", _hoisted_8, " (" + _toDisplayString($props.product.ratings_total) + ") ", 1)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createTextVNode(_toDisplayString($props.product.price), 1), _createElementVNode("span", null, _toDisplayString($data.currency), 1)]), _createElementVNode("div", _hoisted_11, "(" + _toDisplayString($props.product.price) + " " + _toDisplayString($data.currency) + "/unit)", 1)]), _createElementVNode("div", _hoisted_12, [_createTextVNode(" Delivery "), _createElementVNode("b", null, _toDisplayString($data.delivery_date), 1), _hoisted_13, _createTextVNode(" FREE Delivery by Amazon ")])])]);
}